module.exports = __webpack_public_path__ + "img/image-5.1e29475e.webp";